// src/config/plansConfig.ts

// 1. Exportamos la interface para que pueda ser usada en toda la aplicación
export interface Plan {
  id: string;
  title: string;
  price: string;
  total?: string;
  discount?: string;
  isPopular?: boolean;
  amountInCents: number;
}

// 2. Exportamos la constante de planes
export const plans: Plan[] = [
  { id: 'free', title: 'Plan Gratuito', price: 'S/ 0.00', amountInCents: 0 },
  { id: 'monthly', title: 'Plan Mensual', price: 'S/ 50.00', amountInCents: 5000 },
  { id: 'semiannual', title: 'Plan Semestral', price: 'S/ 250.00', total: 'S/ 300.00', discount: 'S/ 50.00', isPopular: true, amountInCents: 25000 },
  { id: 'annual', title: 'Plan Anual', price: 'S/ 450.00', total: 'S/ 600.00', discount: 'S/ 150.00', amountInCents: 45000 },
];